// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_imp@2/3471/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/_to-object.js
// module id = 9
// module chunks = 0